var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.sassStyles.root,attrs:{"data-cy":"wizzard-progress-wide"}},[_c('a-breadcrumb',{attrs:{"routes":_vm.routes},scopedSlots:_vm._u([{key:"itemRender",fn:function({ route }){return [_c('span',{class:{
          [_vm.sassStyles.wizzardActiveStep]: route.path === _vm.currentRoutePath,
          active: route.path === _vm.currentRoutePath,
        },attrs:{"data-cy":"wizzard-step-label"}},[_vm._v(" "+_vm._s(route.stepLabel)+" ")])]}}])},[_c('span',{attrs:{"slot":"separator"},slot:"separator"},[_c('img',{attrs:{"src":_vm.arrowRightPath}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }